import { useStatsigClient } from '@statsig/react-bindings';

/**
 * Hook to get the button label for the Edit Template feature from a Statsig experiment.
 *
 * This hook wraps the 'note_edit_template_label' experiment and returns the button label
 * to be displayed. The experiment allows A/B testing different label variations.
 *
 * @returns The button label text (defaults to 'Edit Note Sections')
 *
 * @example
 * const editButtonLabel = useEditTemplateLabelExperiment();
 * // Use in JSX: <Button>{editButtonLabel}</Button>
 */
export function useEditTemplateLabelExperiment(): string {
  const { client } = useStatsigClient();
  // 'note_edit_template_label' matches the console experiment slug
  const exp = client.getExperiment('note_edit_template_label'); // exposure auto-logged
  return exp.get('button_label', 'Edit Note Sections'); // default guard
}
